import React, { useState } from 'react';
import pray from '../assets/pray.png';
import PrayModal from './PrayModal';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPrayModalOpen, setIsPrayModalOpen] = useState(false);

  return (
    <>
      <nav className="fixed w-full top-0 z-50 bg-black/90 backdrop-blur-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <img src={pray} alt="Hope From The Pope" className="h-10 w-10" />
              <h1 className="ml-3 text-white font-bold text-xl">$HFP</h1>
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <a href="#home" className="text-white hover:text-yellow-400 transition-colors">Home</a>
              <a href="#tokenomics" className="text-white hover:text-yellow-400 transition-colors">Tokenomics</a>
              <a href="#how-to-buy" className="text-white hover:text-yellow-400 transition-colors">How to Buy</a>
              <a href="#roadmap" className="text-white hover:text-yellow-400 transition-colors">Roadmap</a>
              <button 
                onClick={() => setIsPrayModalOpen(true)}
                className="bg-yellow-400 text-black px-4 py-2 rounded-lg font-bold hover:bg-yellow-500 transition-colors flex items-center gap-2"
              >
                <span className="text-lg">🙏</span>
                Pray Now
              </button>
            </div>

            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-white hover:text-yellow-400"
              >
                <span className="sr-only">Open menu</span>
                <div className="space-y-2">
                  <span className={`block w-8 h-0.5 bg-white transform transition duration-300 ${isOpen ? 'rotate-45 translate-y-2.5' : ''}`}></span>
                  <span className={`block w-8 h-0.5 bg-white transition duration-300 ${isOpen ? 'opacity-0' : ''}`}></span>
                  <span className={`block w-8 h-0.5 bg-white transform transition duration-300 ${isOpen ? '-rotate-45 -translate-y-2.5' : ''}`}></span>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`md:hidden ${isOpen ? 'block' : 'hidden'}`}>
          <div className="px-2 pt-2 pb-3 space-y-1 bg-black/90 backdrop-blur-lg">
            <a href="#home" className="block px-3 py-2 text-white hover:text-yellow-400">Home</a>
            <a href="#tokenomics" className="block px-3 py-2 text-white hover:text-yellow-400">Tokenomics</a>
            <a href="#how-to-buy" className="block px-3 py-2 text-white hover:text-yellow-400">How to Buy</a>
            <a href="#roadmap" className="block px-3 py-2 text-white hover:text-yellow-400">Roadmap</a>
            <button 
              onClick={() => setIsPrayModalOpen(true)}
              className="w-full mt-4 bg-yellow-400 text-black px-4 py-2 rounded-lg font-bold hover:bg-yellow-500 flex items-center justify-center gap-2"
            >
              <span className="text-lg">🙏</span>
              Pray Now
            </button>
          </div>
        </div>
      </nav>

      {/* Prayer Modal */}
      <PrayModal 
        isOpen={isPrayModalOpen} 
        onClose={() => setIsPrayModalOpen(false)} 
      />
    </>
  );
};

export default Navbar; 